'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _iBemReact = require('@yandex-lego/i-bem-react');

exports.default = (0, _iBemReact.decl)({
    block: 'i-services',
    elem: 'uri'
}, {
    404: function _(reg) {
        switch (reg) {
            case 'ua':
                return 'http://404.yandex.ua';
            case 'by':
                return 'http://404.yandex.by';
            case 'kz':
                return 'http://404.yandex.kz';
            case 'com':
                return 'http://404.yandex.com';
            case 'tr':
                return 'http://404.yandex.com.tr';
            default:
                return 'http://404.yandex.ru';
        }
    },
    adresa: function adresa() {
        return 'http://adresa.yandex.ru';
    },
    advertising: function advertising(reg) {
        switch (reg) {
            case 'ua':
                return 'https://advertising.yandex.ua';
            case 'by':
                return 'https://advertising.yandex.by';
            case 'kz':
                return 'https://advertising.yandex.kz';
            case 'com':
                return 'https://advertising.yandex.com';
            case 'tr':
                return 'https://yandex.com.tr/adv';
            default:
                return 'https://advertising.yandex.ru';
        }
    },
    afisha: function afisha(reg) {
        switch (reg) {
            case 'ua':
                return 'https://afisha.yandex.ua';
            case 'by':
                return 'https://afisha.yandex.by';
            case 'kz':
                return 'https://afisha.yandex.kz';
            default:
                return 'https://afisha.yandex.ru';
        }
    },
    all: function all(reg) {
        switch (reg) {
            case 'ua':
                return '//yandex.ua/all';
            case 'by':
                return '//yandex.by/all';
            case 'kz':
                return '//yandex.kz/all';
            case 'com':
                return '//yandex.com/all';
            case 'tr':
                return '//yandex.com.tr/all';
            default:
                return '//yandex.ru/all';
        }
    },
    api: function api(reg) {
        switch (reg) {
            case 'com':
                return 'http://api.yandex.com';
            default:
                return 'http://api.yandex.ru';
        }
    },
    appmetrica: function appmetrica(reg) {
        switch (reg) {
            case 'ua':
                return 'https://appmetrica.yandex.ua';
            case 'by':
                return 'https://appmetrica.yandex.by';
            case 'kz':
                return 'https://appmetrica.yandex.kz';
            case 'com':
                return 'https://appmetrica.yandex.com';
            case 'tr':
                return 'https://appmetrica.yandex.com.tr';
            default:
                return 'https://appmetrica.yandex.ru';
        }
    },
    appsearch: function appsearch() {
        return '//appsearch.yandex.ru';
    },
    audience: function audience(reg) {
        switch (reg) {
            case 'ua':
                return 'https://audience.yandex.ua';
            case 'by':
                return 'https://audience.yandex.by';
            case 'kz':
                return 'https://audience.yandex.kz';
            case 'com':
                return 'https://audience.yandex.com';
            case 'tr':
                return 'https://audience.yandex.com.tr';
            default:
                return 'https://audience.yandex.ru';
        }
    },
    auto: function auto(reg) {
        switch (reg) {
            case 'ua':
                return 'https://auto.yandex.ua';
            default:
                return 'https://auto.yandex.ru';
        }
    },
    autoru: function autoru() {
        return 'https://auto.ru';
    },
    avia: function avia(reg) {
        switch (reg) {
            case 'ua':
                return 'https://avia.yandex.ua';
            default:
                return 'https://avia.yandex.ru';
        }
    },
    aziada: function aziada() {
        return 'http://aziada2011.yandex.kz';
    },
    ba: function ba(reg) {
        switch (reg) {
            case 'ua':
                return 'https://ba.yandex.ua';
            case 'by':
                return 'https://ba.yandex.by';
            case 'kz':
                return 'https://ba.yandex.kz';
            case 'com':
                return 'https://ba.yandex.com';
            default:
                return 'https://ba.yandex.ru';
        }
    },
    backapv: function backapv() {
        return 'http://backapv.yandex.ru';
    },
    balance: function balance() {
        return 'https://balance.yandex.ru';
    },
    bar: function bar(reg) {
        switch (reg) {
            case 'ua':
                return 'http://bar.yandex.ua';
            case 'by':
                return 'http://bar.yandex.by';
            case 'kz':
                return 'http://bar.yandex.kz';
            case 'tr':
                return 'http://bar.yandex.com.tr';
            default:
                return 'http://bar.yandex.ru';
        }
    },
    'bar-ie': function barIe(reg) {
        switch (reg) {
            case 'ua':
                return 'http://bar.yandex.ua/ie';
            case 'by':
                return 'http://bar.yandex.by/ie';
            case 'kz':
                return 'http://bar.yandex.kz/ie';
            case 'com':
                return 'http://bar.yandex.com/ie';
            case 'tr':
                return 'http://bar.yandex.com.tr/ie';
            default:
                return 'http://bar.yandex.ru/ie';
        }
    },
    'bar-ie9': function barIe9(reg) {
        switch (reg) {
            case 'ua':
                return 'http://bar.yandex.ua/ie';
            case 'by':
                return 'http://bar.yandex.by/ie';
            case 'kz':
                return 'http://bar.yandex.kz/ie';
            case 'com':
                return 'http://bar.yandex.com/ie';
            case 'tr':
                return 'http://bar.yandex.com.tr/ie';
            default:
                return 'http://bar.yandex.ru/ie';
        }
    },
    bayan: function bayan() {
        return 'http://bayan.yandex.ru';
    },
    blogs: function blogs(reg) {
        switch (reg) {
            case 'ua':
                return 'https://blogs.yandex.ua';
            case 'by':
                return 'https://blogs.yandex.by';
            case 'kz':
                return 'https://blogs.yandex.kz';
            default:
                return 'https://blogs.yandex.ru';
        }
    },
    books: function books() {
        return 'http://books.yandex.ru';
    },
    browser: function browser(reg) {
        switch (reg) {
            case 'ua':
                return 'https://browser.yandex.ua';
            case 'by':
                return 'https://browser.yandex.by';
            case 'kz':
                return 'https://browser.yandex.kz';
            case 'com':
                return 'https://browser.yandex.com';
            case 'tr':
                return 'https://browser.yandex.com.tr';
            default:
                return 'https://browser.yandex.ru';
        }
    },
    calendar: function calendar() {
        return 'https://calendar.yandex.ru';
    },
    catalogwdgt: function catalogwdgt() {
        return 'https://www.yandex.ru/catalog';
    },
    chrome: function chrome() {
        return 'http://chrome.yandex.ru';
    },
    city: function city(reg) {
        switch (reg) {
            case 'ua':
                return 'https://gorod.yandex.ua';
            case 'by':
                return 'https://gorod.yandex.by';
            case 'kz':
                return 'https://gorod.yandex.kz';
            case 'com':
                return 'https://city.yandex.com';
            case 'tr':
                return 'https://city.yandex.com.tr';
            default:
                return 'https://gorod.yandex.ru';
        }
    },
    cityday: function cityday() {
        return 'http://cityday.yandex.ru';
    },
    clickhouse: function clickhouse() {
        return 'https://clickhouse.yandex/';
    },
    collection: function collection() {
        return 'https://collection.yandex.ru';
    },
    commander: function commander(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ru/promo/commander/new?source=tableau_direct';
            case 'by':
                return 'https://yandex.ru/promo/commander/new?source=tableau_direct';
            case 'kz':
                return 'https://yandex.ru/promo/commander/new?source=tableau_direct';
            case 'com':
                return 'https://yandex.ru/promo/commander/new?source=tableau_direct';
            case 'tr':
                return 'https://yandex.ru/promo/commander/new?source=tableau_direct';
            default:
                return 'https://yandex.ru/promo/commander/new?source=tableau_direct';
        }
    },
    company: function company(reg) {
        switch (reg) {
            case 'com':
                return 'https://company.yandex.com';
            case 'tr':
                return 'https://company.yandex.com.tr';
            default:
                return 'https://company.yandex.ru';
        }
    },
    contest: function contest(reg) {
        switch (reg) {
            case 'com':
                return 'https://contest.yandex.com';
            default:
                return 'https://contest.yandex.ru';
        }
    },
    delivery: function delivery() {
        return 'https://delivery.yandex.ru';
    },
    desktop: function desktop() {
        return 'http://desktop.yandex.ru';
    },
    direct: function direct(reg) {
        switch (reg) {
            case 'ua':
                return 'https://direct.yandex.ua';
            case 'by':
                return 'https://direct.yandex.by';
            case 'kz':
                return 'https://direct.yandex.kz';
            case 'com':
                return 'https://direct.yandex.com';
            case 'tr':
                return 'https://direct.yandex.com.tr';
            default:
                return 'https://direct.yandex.ru';
        }
    },
    'direct-api': function directApi(reg) {
        switch (reg) {
            case 'ua':
                return 'https://tech.yandex.ru/direct/?source=tableau_direct';
            case 'by':
                return 'https://tech.yandex.ru/direct/?source=tableau_direct';
            case 'kz':
                return 'https://tech.yandex.ru/direct/?source=tableau_direct';
            case 'com':
                return 'https://tech.yandex.com/direct/?source=tableau_direct';
            case 'tr':
                return 'https://tech.yandex.com/direct/?source=tableau_direct';
            default:
                return 'https://tech.yandex.ru/direct/?source=tableau_direct';
        }
    },
    'direct.market': function directMarket() {
        return 'https://partner.market.yandex.ru/yandex.market/';
    },
    disk: function disk(reg) {
        switch (reg) {
            case 'ua':
                return 'https://disk.yandex.ua';
            case 'by':
                return 'https://disk.yandex.by';
            case 'kz':
                return 'https://disk.yandex.kz';
            case 'com':
                return 'https://disk.yandex.com';
            case 'tr':
                return 'https://disk.yandex.com.tr';
            case 'az':
                return 'https://disk.yandex.az';
            case 'il':
                return 'https://disk.yandex.co.il';
            case 'am':
                return 'https://disk.yandex.com.am';
            case 'ge':
                return 'https://disk.yandex.com.ge';
            case 'ee':
                return 'https://disk.yandex.ee';
            case 'fr':
                return 'https://disk.yandex.fr';
            case 'kg':
                return 'https://disk.yandex.kg';
            case 'lt':
                return 'https://disk.yandex.lt';
            case 'lv':
                return 'https://disk.yandex.lv';
            case 'md':
                return 'https://disk.yandex.md';
            case 'tj':
                return 'https://disk.yandex.tj';
            case 'tm':
                return 'https://disk.yandex.tm';
            case 'uz':
                return 'https://disk.yandex.uz';
            default:
                return 'https://disk.yandex.ru';
        }
    },
    display: function display(reg) {
        switch (reg) {
            case 'tr':
                return 'https://display.yandex.com.tr';
            default:
                return 'https://display.yandex.ru';
        }
    },
    ege: function ege(reg) {
        switch (reg) {
            case 'ua':
                return 'https://zno.yandex.ua';
            default:
                return 'https://ege.yandex.ru';
        }
    },
    expert: function expert() {
        return 'http://expert.yandex.ru';
    },
    feedback: function feedback(reg) {
        switch (reg) {
            case 'ua':
                return 'http://feedback.yandex.ua';
            case 'by':
                return 'http://feedback.yandex.by';
            case 'kz':
                return 'http://feedback.yandex.kz';
            case 'com':
                return 'http://feedback.yandex.com';
            case 'tr':
                return 'http://contact.yandex.com.tr';
            default:
                return 'http://feedback.yandex.ru';
        }
    },
    feedback2: function feedback2(reg) {
        switch (reg) {
            case 'ua':
                return '//feedback2.yandex.ua';
            case 'by':
                return '//feedback2.yandex.by';
            case 'kz':
                return '//feedback2.yandex.kz';
            case 'com':
                return '//feedback2.yandex.com';
            case 'tr':
                return '//contact2.yandex.com.tr';
            default:
                return '//feedback2.yandex.ru';
        }
    },
    ff: function ff() {
        return 'http://ff.yandex.ru';
    },
    fotki: function fotki() {
        return 'https://fotki.yandex.ru';
    },
    fresh: function fresh(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ua';
            case 'by':
                return 'https://yandex.by';
            case 'kz':
                return 'https://yandex.kz';
            case 'com':
                return 'https://yandex.com';
            case 'tr':
                return 'https://yandex.com.tr';
            default:
                return 'https://yandex.ru';
        }
    },
    fx: function fx(reg) {
        switch (reg) {
            case 'ua':
                return 'https://fx.yandex.ua';
            case 'tr':
                return 'https://fx.yandex.com.tr';
            default:
                return 'https://fx.yandex.ru';
        }
    },
    games: function games() {
        return 'http://games.yandex.ru';
    },
    geocontext: function geocontext() {
        return 'https://geocontext.yandex.ru';
    },
    goroda: function goroda() {
        return 'http://goroda.yandex.ru';
    },
    help: function help(reg) {
        switch (reg) {
            case 'ua':
                return 'https://help.yandex.ua';
            case 'com':
                return 'https://help.yandex.com';
            case 'tr':
                return 'https://yardim.yandex.com.tr';
            default:
                return 'https://help.yandex.ru';
        }
    },
    i: function i() {
        return 'http://i.yandex.ru';
    },
    ie: function ie(reg) {
        switch (reg) {
            case 'ua':
                return 'https://ie.yandex.ua';
            case 'tr':
                return 'https://ie.yandex.com.tr';
            default:
                return 'https://ie.yandex.ru';
        }
    },
    images: function images(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ua/images/';
            case 'by':
                return 'https://yandex.by/images/';
            case 'kz':
                return 'https://yandex.kz/images/';
            case 'com':
                return 'https://yandex.com/images/';
            case 'tr':
                return 'https://yandex.com.tr/gorsel/';
            case 'az':
                return 'https://yandex.az/images/';
            case 'il':
                return 'https://yandex.co.il/images/';
            case 'am':
                return 'https://yandex.com.am/images/';
            case 'ge':
                return 'https://yandex.com.ge/images/';
            case 'ee':
                return 'https://yandex.ee/images/';
            case 'fr':
                return 'https://yandex.fr/images/';
            case 'kg':
                return 'https://yandex.kg/images/';
            case 'lt':
                return 'https://yandex.lt/images/';
            case 'lv':
                return 'https://yandex.lv/images/';
            case 'md':
                return 'https://yandex.md/images/';
            case 'tj':
                return 'https://yandex.tj/images/';
            case 'tm':
                return 'https://yandex.tm/images/';
            case 'uz':
                return 'https://yandex.uz/images/';
            default:
                return 'https://yandex.ru/images/';
        }
    },
    'images-com': function imagesCom() {
        return 'https://yandex.com/images/';
    },
    interests: function interests() {
        return 'http://interests.yandex.ru';
    },
    internet: function internet(reg) {
        switch (reg) {
            case 'com':
                return '//internet.yandex.com';
            case 'tr':
                return '//internet.yandex.com.tr';
            default:
                return '//internet.yandex.ru';
        }
    },
    kassa: function kassa() {
        return 'https://kassa.yandex.ru';
    },
    keyboard: function keyboard() {
        return 'http://www.yandex.ru/index_engl_qwerty.html';
    },
    kraski: function kraski() {
        return 'http://kraski.yandex.ru';
    },
    kuda: function kuda() {
        return 'http://kuda.yandex.ru';
    },
    large: function large() {
        return 'http://large.yandex.ru';
    },
    legal: function legal(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ua/legal';
            case 'com':
                return 'https://yandex.com/legal';
            case 'tr':
                return 'https://yandex.com.tr/legal';
            default:
                return 'https://yandex.ru/legal';
        }
    },
    lenta: function lenta() {
        return 'http://lenta.yandex.ru';
    },
    literacy: function literacy() {
        return 'https://literacy.yandex.ru';
    },
    local: function local() {
        return 'http://local.yandex.ru';
    },
    lost: function lost() {
        return 'http://lost.yandex.ru';
    },
    love: function love() {
        return 'http://love.yandex.ru';
    },
    mail: function mail(reg) {
        switch (reg) {
            case 'ua':
                return 'https://mail.yandex.ua';
            case 'by':
                return 'https://mail.yandex.by';
            case 'kz':
                return 'https://mail.yandex.kz';
            case 'com':
                return 'https://mail.yandex.com';
            case 'tr':
                return 'https://mail.yandex.com.tr';
            case 'az':
                return 'https://mail.yandex.az';
            case 'il':
                return 'https://mail.yandex.co.il';
            case 'am':
                return 'https://mail.yandex.com.am';
            case 'ge':
                return 'https://mail.yandex.com.ge';
            case 'ee':
                return 'https://mail.yandex.ee';
            case 'fr':
                return 'https://mail.yandex.fr';
            case 'kg':
                return 'https://mail.yandex.kg';
            case 'lt':
                return 'https://mail.yandex.lt';
            case 'lv':
                return 'https://mail.yandex.lv';
            case 'md':
                return 'https://mail.yandex.md';
            case 'tj':
                return 'https://mail.yandex.tj';
            case 'tm':
                return 'https://mail.yandex.tm';
            case 'uz':
                return 'https://mail.yandex.uz';
            default:
                return 'https://mail.yandex.ru';
        }
    },
    maps: function maps(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ua/maps/';
            case 'com':
                return 'https://yandex.com/maps/';
            case 'tr':
                return 'https://yandex.com.tr/harita/';
            case 'az':
                return 'https://yandex.az/maps/';
            case 'il':
                return 'https://yandex.co.il/maps/';
            case 'am':
                return 'https://yandex.com.am/maps/';
            case 'ge':
                return 'https://yandex.com.ge/maps/';
            case 'ee':
                return 'https://yandex.ee/maps/';
            case 'fr':
                return 'https://yandex.fr/maps/';
            case 'kg':
                return 'https://yandex.kg/maps/';
            case 'lt':
                return 'https://yandex.lt/maps/';
            case 'lv':
                return 'https://yandex.lv/maps/';
            case 'md':
                return 'https://yandex.md/maps/';
            case 'tj':
                return 'https://yandex.tj/maps/';
            case 'tm':
                return 'https://yandex.tm/maps/';
            case 'uz':
                return 'https://yandex.uz/maps/';
            default:
                return 'https://yandex.ru/maps/';
        }
    },
    'maps-com': function mapsCom() {
        return 'https://yandex.com/maps/';
    },
    'maps-wiki': function mapsWiki() {
        return 'http://nk.yandex.ru';
    },
    market: function market(reg) {
        switch (reg) {
            case 'ua':
                return 'https://market.yandex.ua';
            case 'by':
                return 'https://market.yandex.by';
            case 'kz':
                return 'https://market.yandex.kz';
            default:
                return 'https://market.yandex.ru';
        }
    },
    'market.advertising': function marketAdvertising(reg) {
        switch (reg) {
            case 'com':
                return 'https://yandex.com/adv/products/classified/market';
            default:
                return 'https://yandex.ru/adv/products/classified/market';
        }
    },
    master: function master() {
        return 'https://master.yandex.ru';
    },
    metrika: function metrika(reg) {
        switch (reg) {
            case 'ua':
                return 'https://metrika.yandex.ua';
            case 'by':
                return 'https://metrika.yandex.by';
            case 'kz':
                return 'https://metrika.yandex.kz';
            case 'com':
                return 'https://metrica.yandex.com';
            case 'tr':
                return 'https://metrica.yandex.com.tr';
            case 'az':
                return 'https://metrika.yandex.az';
            case 'il':
                return 'https://metrika.yandex.co.il';
            case 'am':
                return 'https://metrika.yandex.com.am';
            case 'ge':
                return 'https://metrika.yandex.com.ge';
            case 'ee':
                return 'https://metrika.yandex.ee';
            case 'fr':
                return 'https://metrika.yandex.fr';
            case 'kg':
                return 'https://metrika.yandex.kg';
            case 'lt':
                return 'https://metrika.yandex.lt';
            case 'lv':
                return 'https://metrika.yandex.lv';
            case 'md':
                return 'https://metrika.yandex.md';
            case 'tj':
                return 'https://metrika.yandex.tj';
            case 'tm':
                return 'https://metrika.yandex.tm';
            case 'uz':
                return 'https://metrika.yandex.uz';
            default:
                return 'https://metrika.yandex.ru';
        }
    },
    metro: function metro() {
        return 'https://metro.yandex.ru';
    },
    mobile: function mobile(reg) {
        switch (reg) {
            case 'ua':
                return 'https://mobile.yandex.ua';
            case 'tr':
                return 'https://mobil.yandex.com.tr';
            default:
                return 'https://mobile.yandex.ru';
        }
    },
    moikrug: function moikrug() {
        return 'http://moikrug.ru';
    },
    money: function money() {
        return 'https://money.yandex.ru';
    },
    museums: function museums() {
        return 'http://18.yandex.ru';
    },
    music: function music(reg) {
        switch (reg) {
            case 'ua':
                return 'https://music.yandex.ua';
            case 'by':
                return 'https://music.yandex.by';
            case 'kz':
                return 'https://music.yandex.kz';
            default:
                return 'https://music.yandex.ru';
        }
    },
    'music-partner': function musicPartner() {
        return 'http://music-partner.yandex.ru';
    },
    nahodki: function nahodki(reg) {
        switch (reg) {
            case 'ua':
                return 'https://nahodki.yandex.ua';
            case 'kz':
                return 'https://nahodki.yandex.kz';
            default:
                return 'https://nahodki.yandex.ru';
        }
    },
    nano: function nano() {
        return 'http://nano.yandex.ru';
    },
    news: function news(reg) {
        switch (reg) {
            case 'ua':
                return 'https://news.yandex.ua';
            case 'by':
                return 'https://news.yandex.by';
            case 'kz':
                return 'https://news.yandex.kz';
            case 'tr':
                return 'https://haber.yandex.com.tr';
            case 'az':
                return 'https://news.yandex.az';
            case 'il':
                return 'https://news.yandex.co.il';
            case 'am':
                return 'https://news.yandex.com.am';
            case 'ge':
                return 'https://news.yandex.com.ge';
            case 'ee':
                return 'https://news.yandex.ee';
            case 'fr':
                return 'https://news.yandex.fr';
            case 'kg':
                return 'https://news.yandex.kg';
            case 'lt':
                return 'https://news.yandex.lt';
            case 'lv':
                return 'https://news.yandex.lv';
            case 'md':
                return 'https://news.yandex.md';
            case 'tj':
                return 'https://news.yandex.tj';
            case 'tm':
                return 'https://news.yandex.tm';
            case 'uz':
                return 'https://news.yandex.uz';
            default:
                return 'https://news.yandex.ru';
        }
    },
    'news-com': function newsCom() {
        return 'https://news.yandex.com';
    },
    notifications: function notifications(reg) {
        switch (reg) {
            case 'ua':
                return 'https://notifications.yandex.ua';
            case 'by':
                return 'https://notifications.yandex.by';
            case 'kz':
                return 'https://notifications.yandex.kz';
            case 'com':
                return 'https://notifications.yandex.com';
            case 'tr':
                return 'https://notifications.yandex.com.tr';
            default:
                return 'https://notifications.yandex.ru';
        }
    },
    oauth: function oauth(reg) {
        switch (reg) {
            case 'com':
                return 'https://oauth.yandex.com';
            default:
                return 'https://oauth.yandex.ru';
        }
    },
    online: function online() {
        return 'http://online.yandex.ru';
    },
    openid: function openid() {
        return 'http://openid.yandex.ru';
    },
    opera: function opera(reg) {
        switch (reg) {
            case 'tr':
                return 'https://opera.yandex.com.tr';
            default:
                return 'https://opera.yandex.ru';
        }
    },
    opinion: function opinion() {
        return 'http://opinion.yandex.ru';
    },
    partners: function partners(reg) {
        switch (reg) {
            case 'ua':
                return 'http://partner.yandex.ua';
            case 'by':
                return 'http://partner.yandex.by';
            case 'kz':
                return 'http://partner.yandex.kz';
            case 'com':
                return 'http://partner.yandex.com';
            default:
                return 'http://partner.yandex.ru';
        }
    },
    'partners-en': function partnersEn(reg) {
        switch (reg) {
            case 'ua':
                return 'http://partner.yandex.ua';
            case 'by':
                return 'http://partner.yandex.by';
            case 'kz':
                return 'http://partner.yandex.kz';
            case 'com':
                return 'http://partner.yandex.com';
            default:
                return 'http://partner.yandex.ru';
        }
    },
    partnersearch: function partnersearch() {
        return 'http://yandex.ru';
    },
    pass: function pass(reg) {
        switch (reg) {
            case 'ua':
                return 'https://pass.yandex.ua';
            case 'by':
                return 'https://pass.yandex.by';
            case 'kz':
                return 'https://pass.yandex.kz';
            case 'com':
                return 'https://pass.yandex.com';
            case 'tr':
                return 'https://pass.yandex.com.tr';
            case 'az':
                return 'https://pass.yandex.az';
            case 'il':
                return 'https://pass.yandex.co.il';
            case 'am':
                return 'https://pass.yandex.com.am';
            case 'ge':
                return 'https://pass.yandex.com.ge';
            case 'ee':
                return 'https://pass.yandex.ee';
            case 'fr':
                return 'https://pass.yandex.fr';
            case 'kg':
                return 'https://pass.yandex.kg';
            case 'lt':
                return 'https://pass.yandex.lt';
            case 'lv':
                return 'https://pass.yandex.lv';
            case 'md':
                return 'https://pass.yandex.md';
            case 'tj':
                return 'https://pass.yandex.tj';
            case 'tm':
                return 'https://pass.yandex.tm';
            case 'uz':
                return 'https://pass.yandex.uz';
            default:
                return 'https://pass.yandex.ru';
        }
    },
    passport: function passport(reg) {
        switch (reg) {
            case 'ua':
                return 'https://passport.yandex.ua';
            case 'by':
                return 'https://passport.yandex.by';
            case 'kz':
                return 'https://passport.yandex.kz';
            case 'com':
                return 'https://passport.yandex.com';
            case 'tr':
                return 'https://passport.yandex.com.tr';
            case 'az':
                return 'https://passport.yandex.az';
            case 'il':
                return 'https://passport.yandex.co.il';
            case 'am':
                return 'https://passport.yandex.com.am';
            case 'ge':
                return 'https://passport.yandex.com.ge';
            case 'ee':
                return 'https://passport.yandex.ee';
            case 'fr':
                return 'https://passport.yandex.fr';
            case 'kg':
                return 'https://passport.yandex.kg';
            case 'lt':
                return 'https://passport.yandex.lt';
            case 'lv':
                return 'https://passport.yandex.lv';
            case 'md':
                return 'https://passport.yandex.md';
            case 'tj':
                return 'https://passport.yandex.tj';
            case 'tm':
                return 'https://passport.yandex.tm';
            case 'uz':
                return 'https://passport.yandex.uz';
            default:
                return 'https://passport.yandex.ru';
        }
    },
    pdd: function pdd() {
        return 'https://pdd.yandex.ru';
    },
    peoplesearch: function peoplesearch(reg) {
        switch (reg) {
            case 'ua':
                return 'http://people.yandex.ua';
            default:
                return 'http://people.yandex.ru';
        }
    },
    perevod: function perevod() {
        return 'https://perevod.yandex.ru';
    },
    plus: function plus() {
        return 'https://plus.yandex.ru';
    },
    probki: function probki(reg) {
        switch (reg) {
            case 'ua':
                return 'http://probki.yandex.ua';
            default:
                return 'http://probki.yandex.ru';
        }
    },
    pulse: function pulse(reg) {
        switch (reg) {
            case 'ua':
                return 'http://blogs.yandex.ua/pulse';
            case 'by':
                return 'http://blogs.yandex.by/pulse';
            case 'kz':
                return 'http://blogs.yandex.kz/pulse';
            default:
                return 'http://blogs.yandex.ru/pulse';
        }
    },
    punto: function punto() {
        return 'https://punto.yandex.ru';
    },
    pvo: function pvo() {
        return 'http://ask.yandex.ru';
    },
    rabota: function rabota(reg) {
        switch (reg) {
            case 'ua':
                return 'https://rabota.yandex.ua';
            case 'by':
                return 'https://rabota.yandex.by';
            case 'kz':
                return 'https://rabota.yandex.kz';
            default:
                return 'https://rabota.yandex.ru';
        }
    },
    radar: function radar(reg) {
        switch (reg) {
            case 'ru':
                return 'https://radar.metrika.yandex?lang=ru';
            case 'com':
                return 'https://radar.metrika.yandex?lang=en';
            case 'tr':
                return 'https://radar.metrika.yandex?lang=tr';
            default:
                return 'https://radar.metrika.yandex';
        }
    },
    rasp: function rasp(reg) {
        switch (reg) {
            case 'ua':
                return 'https://rasp.yandex.ua';
            case 'by':
                return 'https://rasp.yandex.by';
            case 'kz':
                return 'https://rasp.yandex.kz';
            case 'tr':
                return 'https://seferler.yandex.com.tr';
            default:
                return 'https://rasp.yandex.ru';
        }
    },
    realty: function realty(reg) {
        switch (reg) {
            case 'ua':
                return 'https://realty.yandex.ua';
            case 'by':
                return 'https://realty.yandex.by';
            case 'kz':
                return 'https://realty.yandex.kz';
            default:
                return 'https://realty.yandex.ru';
        }
    },
    referats: function referats() {
        return 'https://referats.yandex.ru';
    },
    review: function review(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ua';
            case 'by':
                return 'https://yandex.by';
            case 'kz':
                return 'https://yandex.kz';
            case 'com':
                return 'https://yandex.com';
            case 'tr':
                return 'https://yandex.com.tr';
            default:
                return 'https://yandex.ru';
        }
    },
    rk: function rk() {
        return 'http://rk.yandex.ru';
    },
    root: function root() {
        return 'https://root.yandex.ru';
    },
    school: function school() {
        return 'http://school.yandex.ru';
    },
    search: function search(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ua';
            case 'by':
                return 'https://yandex.by';
            case 'kz':
                return 'https://yandex.kz';
            case 'com':
                return 'https://yandex.com';
            case 'tr':
                return 'https://yandex.com.tr';
            case 'az':
                return 'https://yandex.az';
            case 'il':
                return 'https://yandex.co.il';
            case 'am':
                return 'https://yandex.com.am';
            case 'ge':
                return 'https://yandex.com.ge';
            case 'ee':
                return 'https://yandex.ee';
            case 'fr':
                return 'https://yandex.fr';
            case 'kg':
                return 'https://yandex.kg';
            case 'lt':
                return 'https://yandex.lt';
            case 'lv':
                return 'https://yandex.lv';
            case 'md':
                return 'https://yandex.md';
            case 'tj':
                return 'https://yandex.tj';
            case 'tm':
                return 'https://yandex.tm';
            case 'uz':
                return 'https://yandex.uz';
            default:
                return 'https://yandex.ru';
        }
    },
    serp: function serp(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ua';
            case 'by':
                return 'https://yandex.by';
            case 'kz':
                return 'https://yandex.kz';
            case 'com':
                return 'https://yandex.com';
            case 'tr':
                return 'https://yandex.com.tr';
            case 'az':
                return 'https://yandex.az';
            case 'il':
                return 'https://yandex.co.il';
            case 'am':
                return 'https://yandex.com.am';
            case 'ge':
                return 'https://yandex.com.ge';
            case 'ee':
                return 'https://yandex.ee';
            case 'fr':
                return 'https://yandex.fr';
            case 'kg':
                return 'https://yandex.kg';
            case 'lt':
                return 'https://yandex.lt';
            case 'lv':
                return 'https://yandex.lv';
            case 'md':
                return 'https://yandex.md';
            case 'tj':
                return 'https://yandex.tj';
            case 'tm':
                return 'https://yandex.tm';
            case 'uz':
                return 'https://yandex.uz';
            default:
                return 'https://yandex.ru';
        }
    },
    server: function server() {
        return 'http://company.yandex.ru/technology/server/';
    },
    shtrafi: function shtrafi() {
        return 'https://money.yandex.net/debts';
    },
    site: function site(reg) {
        switch (reg) {
            case 'ua':
                return 'https://site.yandex.ua';
            case 'tr':
                return 'https://ozel.yandex.com.tr';
            default:
                return 'https://site.yandex.ru';
        }
    },
    slovari: function slovari(reg) {
        switch (reg) {
            case 'ua':
                return 'https://slovari.yandex.ua';
            case 'by':
                return 'https://slovari.yandex.by';
            case 'kz':
                return 'https://slovari.yandex.kz';
            default:
                return 'https://slovari.yandex.ru';
        }
    },
    so: function so() {
        return 'http://so.yandex.ru';
    },
    social: function social(reg) {
        switch (reg) {
            case 'ua':
                return 'https://social.yandex.ua';
            case 'by':
                return 'https://social.yandex.by';
            case 'kz':
                return 'https://social.yandex.kz';
            case 'com':
                return 'https://social.yandex.ru';
            case 'tr':
                return 'https://social.yandex.com.tr';
            default:
                return 'https://social.yandex.ru';
        }
    },
    soft: function soft(reg) {
        switch (reg) {
            case 'ua':
                return 'https://soft.yandex.ua';
            case 'tr':
                return 'https://soft.yandex.com.tr';
            default:
                return 'https://soft.yandex.ru';
        }
    },
    sport: function sport(reg) {
        switch (reg) {
            case 'ua':
                return 'http://sport.yandex.ua';
            case 'by':
                return 'http://sport.yandex.by';
            case 'kz':
                return 'http://sport.yandex.kz';
            case 'tr':
                return 'http://spor.yandex.com.tr';
            default:
                return 'http://sport.yandex.ru';
        }
    },
    sprav: function sprav(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ru/sprav';
            case 'by':
                return 'https://sprav.yandex.by';
            case 'kz':
                return 'https://sprav.yandex.kz';
            case 'com':
                return 'https://yandex.com/sprav';
            case 'tr':
                return 'https://rehber.yandex.com.tr';
            default:
                return 'https://sprav.yandex.ru';
        }
    },
    start: function start(reg) {
        switch (reg) {
            case 'ua':
                return 'https://help.yandex.ua/start/';
            case 'com':
                return 'https://help.yandex.com/start/';
            case 'tr':
                return 'https://yardim.yandex.com.tr/start';
            default:
                return 'https://help.yandex.ru/start/';
        }
    },
    stat: function stat(reg) {
        switch (reg) {
            case 'ua':
                return 'https://stat.yandex.ua';
            case 'by':
                return 'https://stat.yandex.by';
            default:
                return 'https://stat.yandex.ru';
        }
    },
    subs: function subs() {
        return 'https://subs.yandex.ru';
    },
    support: function support(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ua/support/';
            case 'by':
                return 'https://yandex.by/support/';
            case 'kz':
                return 'https://yandex.kz/support/';
            case 'com':
                return 'https://yandex.com/support/';
            case 'tr':
                return 'https://yandex.com.tr/support/';
            default:
                return 'https://yandex.ru/support/';
        }
    },
    surveys: function surveys() {
        return 'https://surveys.yandex.ru';
    },
    taxi: function taxi() {
        return 'https://taxi.yandex.ru';
    },
    telephony: function telephony() {
        return 'https://telephony.yandex.ru/';
    },
    terms: function terms() {
        return 'http://terms.yandex.ru';
    },
    tests: function tests() {
        return 'http://tests.yandex.ru';
    },
    ticket: function ticket() {
        return 'http://ticket.yandex.ru';
    },
    time: function time(reg) {
        switch (reg) {
            case 'ua':
                return 'https://time.yandex.ua';
            case 'by':
                return 'https://time.yandex.by';
            case 'kz':
                return 'https://time.yandex.kz';
            case 'com':
                return 'https://time.yandex.com';
            case 'tr':
                return 'https://saat.yandex.com.tr';
            default:
                return 'https://time.yandex.ru';
        }
    },
    toloka: function toloka(reg) {
        switch (reg) {
            case 'com':
                return 'https://toloka.yandex.com';
            case 'tr':
                return 'https://toloka.yandex.com.tr';
            default:
                return 'https://toloka.yandex.ru';
        }
    },
    toster: function toster() {
        return 'http://toster.yandex.ru';
    },
    translate: function translate(reg) {
        switch (reg) {
            case 'ua':
                return 'https://translate.yandex.ua';
            case 'by':
                return 'https://translate.yandex.by';
            case 'kz':
                return 'https://translate.yandex.kz';
            case 'com':
                return 'https://translate.yandex.com';
            case 'tr':
                return 'https://ceviri.yandex.com.tr';
            case 'az':
                return 'https://translate.yandex.az';
            case 'il':
                return 'https://translate.yandex.co.il';
            case 'am':
                return 'https://translate.yandex.com.am';
            case 'ge':
                return 'https://translate.yandex.com.ge';
            case 'ee':
                return 'https://translate.yandex.ee';
            case 'fr':
                return 'https://translate.yandex.fr';
            case 'kg':
                return 'https://translate.yandex.kg';
            case 'lt':
                return 'https://translate.yandex.lt';
            case 'lv':
                return 'https://translate.yandex.lv';
            case 'md':
                return 'https://translate.yandex.md';
            case 'tj':
                return 'https://translate.yandex.tj';
            case 'tm':
                return 'https://translate.yandex.tm';
            case 'uz':
                return 'https://translate.yandex.uz';
            default:
                return 'https://translate.yandex.ru';
        }
    },
    tune: function tune(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ua/tune';
            case 'by':
                return 'https://yandex.by/tune';
            case 'kz':
                return 'https://yandex.kz/tune';
            case 'com':
                return 'https://yandex.com/tune';
            case 'tr':
                return 'https://yandex.com.tr/tune';
            case 'uz':
                return 'https://yandex.uz/tune';
            default:
                return 'https://yandex.ru/tune';
        }
    },
    tv: function tv(reg) {
        switch (reg) {
            case 'ua':
                return 'https://tv.yandex.ua';
            case 'by':
                return 'https://tv.yandex.by';
            case 'kz':
                return 'https://tv.yandex.kz';
            default:
                return 'https://tv.yandex.ru';
        }
    },
    uslugi: function uslugi() {
        return 'http://uslugi.yandex.ru';
    },
    video: function video(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ua/video/';
            case 'by':
                return 'https://yandex.by/video/';
            case 'kz':
                return 'https://yandex.kz/video/';
            case 'com':
                return 'https://yandex.com/video/';
            case 'tr':
                return 'https://yandex.com.tr/video/';
            case 'az':
                return 'https://yandex.az/video/';
            case 'il':
                return 'https://yandex.co.il/video/';
            case 'am':
                return 'https://yandex.com.am/video/';
            case 'ge':
                return 'https://yandex.com.ge/video/';
            case 'ee':
                return 'https://yandex.ee/video/';
            case 'fr':
                return 'https://yandex.fr/video/';
            case 'kg':
                return 'https://yandex.kg/video/';
            case 'lt':
                return 'https://yandex.lt/video/';
            case 'lv':
                return 'https://yandex.lv/video/';
            case 'md':
                return 'https://yandex.md/video/';
            case 'tj':
                return 'https://yandex.tj/video/';
            case 'tm':
                return 'https://yandex.tm/video/';
            case 'uz':
                return 'https://yandex.uz/video/';
            default:
                return 'https://yandex.ru/video/';
        }
    },
    'video-com': function videoCom() {
        return 'https://yandex.com/video/';
    },
    vno: function vno() {
        return 'https://zno.yandex.ua';
    },
    wdgt: function wdgt(reg) {
        switch (reg) {
            case 'ua':
                return 'https://wdgt.yandex.ua';
            case 'by':
                return 'https://wdgt.yandex.by';
            case 'kz':
                return 'https://wdgt.yandex.kz';
            case 'tr':
                return 'https://wdgt.yandex.com.tr';
            default:
                return 'https://wdgt.yandex.ru';
        }
    },
    weather: function weather(reg) {
        switch (reg) {
            case 'ua':
                return 'https://pogoda.yandex.ua';
            case 'by':
                return 'https://pogoda.yandex.by';
            case 'kz':
                return 'https://pogoda.yandex.kz';
            case 'tr':
                return 'https://hava.yandex.com.tr';
            case 'az':
                return 'https://pogoda.yandex.az';
            case 'il':
                return 'https://pogoda.yandex.co.il';
            case 'am':
                return 'https://pogoda.yandex.com.am';
            case 'ge':
                return 'https://pogoda.yandex.com.ge';
            case 'ee':
                return 'https://pogoda.yandex.ee';
            case 'fr':
                return 'https://pogoda.yandex.fr';
            case 'kg':
                return 'https://pogoda.yandex.kg';
            case 'lt':
                return 'https://pogoda.yandex.lt';
            case 'lv':
                return 'https://pogoda.yandex.lv';
            case 'md':
                return 'https://pogoda.yandex.md';
            case 'tj':
                return 'https://pogoda.yandex.tj';
            case 'tm':
                return 'https://pogoda.yandex.tm';
            case 'uz':
                return 'https://pogoda.yandex.uz';
            default:
                return 'https://pogoda.yandex.ru';
        }
    },
    webmaster: function webmaster(reg) {
        switch (reg) {
            case 'ua':
                return 'https://webmaster.yandex.ua';
            case 'com':
                return 'https://webmaster.yandex.com';
            case 'tr':
                return 'https://webmaster.yandex.com.tr';
            default:
                return 'https://webmaster.yandex.ru';
        }
    },
    'webmaster-api': function webmasterApi(reg) {
        switch (reg) {
            case 'com':
                return 'https://tech.yandex.com/webmaster/';
            case 'tr':
                return 'https://tech.yandex.com/webmaster/';
            default:
                return 'https://tech.yandex.ru/webmaster/';
        }
    },
    widgets: function widgets(reg) {
        switch (reg) {
            case 'ua':
                return 'https://widgets.yandex.ua';
            case 'by':
                return 'https://widgets.yandex.by';
            case 'kz':
                return 'https://widgets.yandex.kz';
            case 'tr':
                return 'https://widgets.yandex.com.tr';
            default:
                return 'https://widgets.yandex.ru';
        }
    },
    wordstat: function wordstat() {
        return 'https://wordstat.yandex.ru';
    },
    wow: function wow() {
        return 'http://my.ya.ru';
    },
    www: function www(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yandex.ua';
            case 'by':
                return 'https://yandex.by';
            case 'kz':
                return 'https://yandex.kz';
            case 'com':
                return 'https://yandex.com';
            case 'tr':
                return 'https://yandex.com.tr';
            case 'az':
                return 'https://yandex.az';
            case 'il':
                return 'https://yandex.co.il';
            case 'am':
                return 'https://yandex.com.am';
            case 'ge':
                return 'https://yandex.com.ge';
            case 'ee':
                return 'https://yandex.ee';
            case 'fr':
                return 'https://yandex.fr';
            case 'kg':
                return 'https://yandex.kg';
            case 'lt':
                return 'https://yandex.lt';
            case 'lv':
                return 'https://yandex.lv';
            case 'md':
                return 'https://yandex.md';
            case 'tj':
                return 'https://yandex.tj';
            case 'tm':
                return 'https://yandex.tm';
            case 'uz':
                return 'https://yandex.uz';
            default:
                return 'https://yandex.ru';
        }
    },
    xmlsearch: function xmlsearch(reg) {
        switch (reg) {
            case 'ua':
                return 'https://xml.yandex.ua';
            case 'by':
                return 'https://xml.yandex.by';
            case 'kz':
                return 'https://xml.yandex.kz';
            case 'com':
                return 'https://xml.yandex.com';
            case 'tr':
                return 'https://xml.yandex.com.tr';
            default:
                return 'https://xml.yandex.ru';
        }
    },
    yaca: function yaca(reg) {
        switch (reg) {
            case 'ua':
                return 'https://yaca.yandex.ua';
            case 'by':
                return 'https://yaca.yandex.by';
            default:
                return 'https://yaca.yandex.ru';
        }
    },
    yamb: function yamb() {
        return 'https://yamb.yandex.ru';
    },
    zakladki: function zakladki() {
        return 'http://zakladki.yandex.ru';
    },
    znatoki: function znatoki() {
        return 'https://yandex.ru/znatoki/';
    }
}); /*      ((   ))     *\
    (@)                          / |\      ))_((     /| \
    |-|                         /  | \    (/\|/\)   / |  \                          (@)
    | | -----------------------/---|-voV---\`|'/--Vov-|---\-------------------------|-|
    |-|                              '^`   (o o)  '^`                               | |
    | |                                    `\Y/'                                    |-|
    |-| Этот файл сгенерирован автоматически. Вручную править не нужно!             | |
    | | Чтобы обновить шаблоны, внесите правки в npm-модуль @yandex-lego/services   |-|
    |-| и запустите i-services__uri.assets/generator.js                             |-|
    |_|_____________________________________________________________________________| |
    (@)                     l   /\ /       ( (        \ /\   l                    `\|-|
    l /   V         \ \        V   \ l                      (@)
    l/              _) )_           \I
               \*/